<template>
    <div class="main">
        <c-panel title="ACESSOS NÃO IDENTIFICADOS" titleIcon="fas fa-user-slash">
            <el-alert type="warning" :closable="false" class="u-mb-15"
                title="Eventos que o equipamento registrou mas não conseguiu atribuir a um aluno."
                description="Rosto desconhecido, score abaixo do mínimo ou aluno sem matrícula ativa nesta escola. Nenhum vira presença sozinho — alguém precisa decidir."></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" filterable style="width: 100%;" @change="carregar">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="5">
                        <el-form-item label="Data" class="u-mb-0">
                            <el-date-picker v-model="data" type="date" clearable format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd" style="width: 100%;" @change="carregar"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="12" :sm="11" class="u-text-right u-mt-25">
                        <el-button size="small" icon="el-icon-refresh" @click="carregar">ATUALIZAR</el-button>
                    </el-col>
                </el-row>
            </el-form>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 160px;">Data/hora</th>
                            <th style="width: 110px;" class="u-text-center">Direção</th>
                            <th style="width: 90px;" class="u-text-center">Score</th>
                            <th>Equipamento</th>
                            <th style="width: 220px;" class="u-text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody v-if="statusList">
                        <tr v-for="e in items" :key="e.id">
                            <td>{{ dataHora(e.data_hora) }}</td>
                            <td class="u-text-center">
                                <el-tag size="mini" :type="e.direcao === 'entrada' ? 'success' : 'info'">{{ e.direcao }}</el-tag>
                            </td>
                            <td class="u-text-center">{{ e.score_confianca !== null ? e.score_confianca + '%' : '—' }}</td>
                            <td>{{ e.equipamento }} <small class="u-text-muted">({{ e.identificador }})</small></td>
                            <td class="u-text-center acao">
                                <el-button v-if="podeEscrever" size="mini" type="primary" plain @click="abrirIdentificar(e)">IDENTIFICAR</el-button>
                                <el-button class="u-ml-10" v-if="podeEscrever" size="mini" type="danger" plain @click="descartar(e)">DESCARTAR</el-button>
                                <span v-if="!podeEscrever">—</span>
                            </td>
                        </tr>
                        <tr v-if="items.length === 0"><td colspan="5" class="u-text-center">Nenhum acesso pendente de identificação.</td></tr>
                    </tbody>
                </table>
                <div v-if="!statusList" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>
            </div>

            <!-- ==================== IDENTIFICAR ==================== -->
            <el-dialog title="Identificar acesso" :visible.sync="dialogo" width="600px">
                <el-alert v-if="atual" type="info" :closable="false" class="u-mb-15"
                    :title="dataHora(atual.data_hora) + ' — ' + atual.direcao"
                    description="Ao identificar, a presença do dia é lançada conforme a configuração de frequência da turma. Se o professor já lançou algo diferente, o sistema registra conflito em vez de sobrescrever."></el-alert>

                <el-form label-position="top">
                    <el-form-item label="Turma">
                        <el-select v-model="turmaId" filterable style="width: 100%;" @change="carregarAlunos"
                            no-data-text="Nenhuma turma nesta escola/período">
                            <el-option v-for="t in turmas" :key="t.id" :value="t.id" :label="t.nome"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="Aluno">
                        <el-select v-model="alunoId" filterable style="width: 100%;" :disabled="!turmaId"
                            no-data-text="Nenhum aluno enturmado">
                            <el-option v-for="a in alunos" :key="a.aluno_id" :value="a.aluno_id" :label="a.nome_aluno"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>

                <span slot="footer">
                    <el-button @click="dialogo = false">CANCELAR</el-button>
                    <el-button class="u-ml-10" type="primary" :disabled="!alunoId" @click="identificar">IDENTIFICAR</el-button>
                </span>
            </el-dialog>
        </c-panel>
    </div>
</template>
<script>
/** BLOCO J — item 128: fila de conferência dos acessos não identificados. */
export default {
    data: () => ({
        statusList: true, instituicaoId: null, instituicoes: [], data: '', items: [],
        dialogo: false, atual: null, turmas: [], alunos: [], turmaId: null, alunoId: null,
        periodoId: null
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) { this.instituicoes = [inst]; this.instituicaoId = inst.id }

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
            this.$store.getters.getHeaderAuth
        ).then(r => { if (Array.isArray(r.data) && r.data.length) this.instituicoes = r.data })
         .catch(() => {}).then(() => this.carregar())
    },
    methods: {
        carregar () {
            if (!this.instituicaoId) return
            this.statusList = false

            const payload = { instituicao_id: this.instituicaoId, situacao: 'nao_identificado' }
            if (this.data) payload.data = this.data

            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/evento-acesso/getAllPaginate?page=1`,
                payload, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) {
                    window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' })
                    this.statusList = true; return
                }
                this.items = r.data.data || []; this.statusList = true
            }).catch(e => { this.statusList = true; this.$store.commit('throwException', e) })
        },
        abrirIdentificar (e) {
            this.atual = e
            this.turmaId = null; this.alunoId = null; this.alunos = []
            this.dialogo = true

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/turma/getAllTurmas/${this.instituicaoId}/${this.periodoId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.turmas = Array.isArray(r.data) ? r.data : Object.values(r.data || {}).flat() })
             .catch(err => this.$store.commit('throwException', err))
        },
        carregarAlunos () {
            this.alunos = []; this.alunoId = null
            if (!this.turmaId) return

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/getAlunosForDiario/${this.turmaId}`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.alunos = Array.isArray(r.data) ? r.data : [] })
             .catch(e => this.$store.commit('throwException', e))
        },
        identificar () {
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/evento-acesso/identificar/${this.atual.id}`,
                { aluno_id: this.alunoId }, this.$store.getters.getHeaderAuth
            ).then(r => {
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }

                let msg = r.data.mensagem
                if (r.data.conflito) msg += ' Atenção: houve divergência com o lançamento do professor — registrada como conflito no diário.'
                else if (r.data.gerou_frequencia) msg += ' Presença do dia lançada.'
                else if (r.data.motivo) msg += ' ' + r.data.motivo

                window.eventBus.$emit('alert', { msg: msg, type: r.data.conflito ? 'warning' : 'success' })
                this.dialogo = false
                this.carregar()
            }).catch(e => this.$store.commit('throwException', e))
        },
        descartar (e) {
            this.$prompt('Motivo do descarte:', 'Descartar acesso', {
                confirmButtonText: 'Descartar', cancelButtonText: 'Cancelar',
                inputPlaceholder: 'Ex.: visitante.'
            }).then(({ value }) => {
                this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/evento-acesso/descartar/${e.id}`,
                    { motivo: value }, this.$store.getters.getHeaderAuth
                ).then(r => {
                    if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                    window.eventBus.$emit('alert', { msg: r.data.mensagem, type: 'success' })
                    this.carregar()
                }).catch(err => this.$store.commit('throwException', err))
            }).catch(() => {})
        },
        dataHora (d) {
            if (!d) return '—'
            const p = d.substring(0, 10).split('-')
            return `${p[2]}/${p[1]}/${p[0]} ${d.substring(11, 19)}`
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
